import { render, staticRenderFns } from "./coverage.vue?vue&type=template&id=90276b84&scoped=true"
import script from "./coverage.vue?vue&type=script&lang=js"
export * from "./coverage.vue?vue&type=script&lang=js"
import style0 from "./coverage.vue?vue&type=style&index=0&id=90276b84&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90276b84",
  null
  
)

export default component.exports